import AppModal from '@/components/common/AppModal';
import { SplashState } from '@/state/SplashState';

interface PrivacyPolicyProps {
    handleWindowChange: (window: SplashState) => void;
}

export const PrivacyPolicy = ({ handleWindowChange }: PrivacyPolicyProps) => {
    return (
        <AppModal
            className="c-information-modal c-policy"
            show
            title="Personvernerklæring"
            onClose={() => handleWindowChange(SplashState.NONE)}
            headerActions={
                <button
                    type="button"
                    title="Tilbake"
                    className="c-app-modal__header-action c-policy__back"
                    onClick={() => handleWindowChange(SplashState.MAIN)}
                    aria-label="Gå tilbake fra personvernerklæring"
                    id="back_privacypolicy_header_button"
                >
                    <i
                        className="material-icons c-app-modal__header-action-icon c-policy__back-icon"
                        aria-hidden="true"
                    >
                        arrow_back
                    </i>
                </button>
            }
        >
            <main className="c-policy-main">
                <h2 className="c-policy-main__title">Hvilke brukerdata lagrer vi?</h2>
                <h3 className="c-policy-main__title">Sensitive opplysninger</h3>
                <p>
                    Vegkart hverken lagrer eller sender sensitive opplysninger om
                    brukeren.
                </p>
                <h3 className="c-policy-main__title">Cookies</h3>
                <p>
                    For hver gang man bruker applikasjonen blir det opprettet en unik og
                    tilfeldig generert &nbsp;sesjons-id som benyttes i logging av Vegkart,
                    og ved forespørsler til NVDB-API-et. &nbsp;Denne slettes når brukeren
                    lukker nettleseren.
                </p>
                <p className="c-policy-main__updated">
                    Sist oppdatert:{' '}
                    <span className="c-policy-main__bold">01.01.2025</span>.
                </p>
            </main>
            <footer className="c-policy-footer">
                <hr />
                <p className="c-policy-footer__text">
                    Ved spørsmål angående personvern, ta kontakt på: &nbsp;
                    <span className="c-policy-footer__email">
                        <a href="mailto:vegkart-support@vegvesen.no">
                            vegkart-support@vegvesen.no
                        </a>
                        .
                    </span>
                </p>
            </footer>
        </AppModal>
    );
};
